'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dialog = require('material-ui/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _ = require('../');

var _2 = _interopRequireDefault(_);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SignupForm = (_temp = _class = function (_AuthForm) {
  _inherits(SignupForm, _AuthForm);

  function SignupForm() {
    _classCallCheck(this, SignupForm);

    return _possibleConstructorReturn(this, (SignupForm.__proto__ || Object.getPrototypeOf(SignupForm)).apply(this, arguments));
  }

  _createClass(SignupForm, [{
    key: 'onChange',
    value: function onChange(event) {
      var _event$target = event.target,
          name = _event$target.name,
          value = _event$target.value;
      var data = this.state.data;
      this.setState({
        data: _extends({}, data, _defineProperty({}, name, value))
      });
    }
  }, {
    key: 'renderFields',
    value: function renderFields() {
      var _this2 = this;

      var _context = this.context,
          Grid = _context.Grid,
          PhoneField = _context.PhoneField;
      var data = this.state.data;

      var _ref = data || {},
          username = _ref.username,
          email = _ref.email,
          phone = _ref.phone,
          fullname = _ref.fullname,
          password = _ref.password;

      return _react2.default.createElement(Grid, {
        container: true,
        spacing: 8
      }, _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, this.renderField(_react2.default.createElement(_TextField2.default, {
        label: this.lexicon("Login"),
        name: 'username',
        fullWidth: true,
        value: username || "",
        onChange: function onChange(event) {
          return _this2.onChange(event);
        }
      }))), _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, this.renderField(_react2.default.createElement(_TextField2.default, {
        label: this.lexicon("Email"),
        name: 'email',
        fullWidth: true,
        value: email || "",
        onChange: function onChange(event) {
          return _this2.onChange(event);
        }
      }))), _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, this.renderField(_react2.default.createElement(PhoneField, {
        label: this.lexicon("Phone"),
        name: 'phone',
        fullWidth: true,
        value: phone || "",
        onChange: function onChange(event) {
          return _this2.onChange(event);
        }
      }))), _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, this.renderField(_react2.default.createElement(_TextField2.default, {
        label: this.lexicon("Fullname"),
        name: 'fullname',
        fullWidth: true,
        value: fullname || "",
        onChange: function onChange(event) {
          return _this2.onChange(event);
        }
      }))), _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, this.renderField(_react2.default.createElement(_TextField2.default, {
        label: this.lexicon("Password"),
        name: 'password',
        type: 'password',
        fullWidth: true,
        value: password || "",
        onChange: function onChange(event) {
          return _this2.onChange(event);
        }
      }))));
    }
  }, {
    key: 'signup',
    value: function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee() {
        var _this3 = this;

        var _ref3, _ref3$signup, signup, _state, signupInRequest, data, result;

        return _regenerator2.default.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref3 = this.context.query || {}, _ref3$signup = _ref3.signup, signup = _ref3$signup === undefined ? '\n        mutation signup(\n          $data:UserCreateInput!\n        ){\n          response: signup(\n            data:$data\n          ){\n            success\n            message\n            errors{\n              key\n              message\n            }\n            token\n            data{\n              ...user\n            }\n          }\n        }\n        \n        \n        fragment user on User {\n          id\n          username\n          email\n          phone\n          showEmail\n          showPhone\n          sudo\n          hasEmail\n          hasPhone\n        }\n      ' : _ref3$signup;
                _state = this.state, signupInRequest = _state.signupInRequest, data = _state.data;

                if (!signupInRequest) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                this.setState({
                  signupInRequest: true
                });
                _context2.next = 7;
                return this.mutate({
                  mutation: (0, _graphqlTag2.default)(signup),
                  variables: {
                    data: data
                  }
                }).then(function (r) {
                  _this3.onAuth(r);

                  return r;
                }).catch(function (error) {
                  console.error(error);
                  return error;
                });

              case 7:
                result = _context2.sent;
                this.setState({
                  signupInRequest: false
                });
                return _context2.abrupt('return', result);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee, this);
      }));

      function signup() {
        return _ref2.apply(this, arguments);
      }

      return signup;
    }()
  }, {
    key: 'cleanForm',
    value: function cleanForm() {
      this.setState({
        data: null
      });
      this.switchForm("signin");
      return _get(SignupForm.prototype.__proto__ || Object.getPrototypeOf(SignupForm.prototype), 'cleanForm', this).call(this);
    }
  }, {
    key: 'renderForm',
    value: function renderForm() {
      var _this4 = this;

      _objectDestructuringEmpty(this.context);

      var data = this.state.data;
      var useMetamask = this.props.useMetamask;
      var actions = [];
      var values = Object.values(_extends({}, data)).filter(function (n) {
        return n;
      });

      if (useMetamask) {
        actions.push(_react2.default.createElement(_Button2.default, {
          key: 'metamask' // color="primary"
          ,
          onClick: function onClick(event) {
            _this4.switchForm("metamask");
          },
          size: 'small'
        }, this.lexicon("Metamask")));
      }

      actions.push(_react2.default.createElement(_Button2.default, {
        key: 'cancel' // color="primary"
        ,
        onClick: function onClick(event) {
          _this4.closeForm();
        },
        size: 'small'
      }, this.lexicon("Cancel")));

      if (values.length) {
        actions.push(_react2.default.createElement(_Button2.default, {
          key: 'submit',
          color: 'primary',
          type: 'submit',
          size: 'small'
        }, this.lexicon("Signup")));
      } else {
        actions.unshift(_react2.default.createElement(_Button2.default, {
          key: 'switchForm' // color="primary"
          ,
          onClick: function onClick(event) {
            _this4.switchForm("signin");
          },
          size: 'small'
        }, this.lexicon("Signin")));
      }

      return _react2.default.createElement('form', {
        style: {
          width: "100%"
        },
        onSubmit: function onSubmit(event) {
          event.preventDefault();

          _this4.signup();
        }
      }, _react2.default.createElement(_Dialog.DialogTitle, null, this.lexicon("Signup")), _react2.default.createElement(_Dialog.DialogContent, null, this.renderFields()), _react2.default.createElement(_Dialog.DialogActions, null, actions));
    } // render() {
    //   return (
    //     <div>
    //     </div>
    //   );
    // }

  }]);

  return SignupForm;
}(_2.default), _class.propTypes = _extends({}, _2.default.propTypes), _temp);
exports.default = SignupForm;
module.exports = exports['default'];